import { css, useTheme } from "@emotion/react";

import parseStyle from "./parseStyle.js";
import useThemeProps from "./useThemeProps.jsx";

export default function Avatar(props) {
  props = useThemeProps({ props, name: "Avatar" });
  let {
    image,
    components = {},
    border,
    borderColor,
    style,
    ...restProps
  } = props;
  components = { Image: "img", ...components };
  const { Image } = components;
  const theme = useTheme();
  borderColor = borderColor ? theme.getColor(borderColor) : "";
  if (image) {
    return (
      <Image
        {...image}
        {...restProps}
        css={css`
          aspect-ratio: 1;
          border-radius: 50%;
          max-width: 100%;
          height: auto;
          width: auto;
          border: ${border};
          border-color: ${borderColor};
          ${parseStyle(style, theme)}
        `}
      />
    );
  }
  return null;
}
